<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="component-container mat-elevation-z8">
  <app-admin-event-list [refresh]="refresh"></app-admin-event-list>
</div>